export function formatProviderListingsViewAllCaption({
    isSearching,
    isQueryActive,
    matchCount,
    availableCount,
}: {
    isSearching: boolean;
    isQueryActive: boolean;
    matchCount: number;
    availableCount: number;
}): string {
    if (isSearching) return "Searching…";
    if (isQueryActive) {
        return `${matchCount.toLocaleString()} ${matchCount === 1 ? "match" : "matches"}`;
    }
    return `${availableCount.toLocaleString()} available`;
}
